import { SaveDataKeys } from '../SaveDataKeys';
import { SettingsSaveData } from '../SettingsManager';

export class PlatformManager {
    private static _instance: PlatformManager;
    protected _hasNoAdsPass: boolean = false;

    public static getInstance(): PlatformManager {
        return this._instance || (this._instance = new this());
    }

    public async setLoadingProgress(progress: number): Promise<void> {
        return FBInstant.setLoadingProgress(progress);
    }

    public startGameAsync(): Promise<void> {
        return FBInstant.startGameAsync();
    }

    public initializeAsync(): Promise<void> {
        return FBInstant.initializeAsync();
    }

    public hasNoAdsPass(): boolean {
        return this._hasNoAdsPass;
    }

    public buyNoAdsPass(): void {
        //
    }

    public retrieveSettings(): Promise<SettingsSaveData> {
        return this.getSaveData([SaveDataKeys.settingsMusic, SaveDataKeys.settingsSFX, SaveDataKeys.settingsVibrate]);
    }

    public getSaveData(keys: SaveDataKeys | SaveDataKeys[]): Promise<any> {
        let keySet: string[] = [];
        if (Array.isArray(keys)) {
            keySet = keys;
        } else {
            keySet.push(keys);
        }
        return FBInstant.player
            .getDataAsync(keySet);
    }

    public async retreiveNumberOfSessions(): Promise<number> {
        return FBInstant.player
            .getDataAsync([SaveDataKeys.numberOfSessions]);
    }

    public saveData(key: SaveDataKeys, value: any): void {
        const saveData: {} = {};
        saveData[key] = value;
        FBInstant.player.setDataAsync(saveData);
    }

    public getUserLanguage(): string {
        return 'EN';
    }
}